module.exports = __webpack_public_path__ + "static/media/pic_banner_representative.a7df0199.jpg";